module.exports = __webpack_public_path__ + "static/business-616feec0f27cb52a57e2191422f4e866.jpg";